import React, { useEffect, useState } from "react";
import { Table, DatePicker, Typography, Space, Card } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { getCompanyReports } from "../../services/reports";
import { useParams } from "react-router-dom";

const { Title } = Typography;
const { RangePicker } = DatePicker;

const CompanyRevenueReport = () => {
  let {tenantId} = useParams()
  const [data, setData] = useState([]);
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(1, "month"),
    dayjs(),
  ]);
  const [loading, setLoading] = useState(false);

  const fetchReport = async (startDate, endDate) => {
    try {
      setLoading(true);
      const res = await getCompanyReports({startDate,endDate,tenantId})
      setData(res?.data || []);
    } catch (error) {
      console.error("Error fetching report:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport(dateRange[0], dateRange[1]);
  }, [dateRange]);

  const handleDateChange = (dates) => {
    if (!dates) return;
    setDateRange(dates);
    fetchReport(dates[0], dates[1]);
  };

  const columns = [
    {
      title: "Company Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Company ID",
      dataIndex: "_id",
      key: "_id",
    },
    // {
    //   title: "Tenant ID",
    //   dataIndex: "tenantId",
    //   key: "tenantId",
    // },
    {
      title: "Total Revenue",
      dataIndex: "totalRevenue",
      key: "totalRevenue",
      render: (value) => `₹ ${value?.toLocaleString()}`,
    },
  ];

  return (
    <Card>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", rowGap: 10 }}>
          <Title level={4}>Company Revenue Report</Title>
          <RangePicker
            value={dateRange}
            onChange={handleDateChange}
            allowClear={false}
          />
        </div>
        <Table
          dataSource={data}
          columns={columns}
          rowKey="_id"
          loading={loading}
          pagination={{ pageSize: 5 }}
        />
      </Space>
    </Card>
  );
};

export default CompanyRevenueReport;
